import { render, staticRenderFns } from "./StaticPagesHeader.vue?vue&type=template&id=79ad3b99&"
import script from "./StaticPagesHeader.vue?vue&type=script&lang=ts&"
export * from "./StaticPagesHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports